import { RoleCreateForm, RoleList } from "modules/company";
import { Title } from "modules/layout";
import { useRouter } from "next/router";
import React from "react";
import { api } from "shared/api";
import { CompanySettingsLayout } from "./_layout";

const CompanyRolesPage = () => {
  const { query } = useRouter();
  const companySlug = query.company as string;

  const roles = api.companyRbac.useCompanyEmployeeRoleList(companySlug);

  return (
    <CompanySettingsLayout>
      <Title>Роли</Title>

      <RoleCreateForm companySlug={companySlug} onSuccess={roles.mutate} />
      <RoleList companySlug={companySlug} {...roles} />
    </CompanySettingsLayout>
  );
};

export default CompanyRolesPage;
